import { InputNumber, message, Upload } from 'hljd'
import React, { Component } from 'react'

const addchangeAttr = arr => arr.map(e => ({ ...e, isChanged: true }))

const picPrevCheck = (file, fileList) => {
  if (fileList.length > 10) {
    message.error({
      content: '上传图片数量不得超过10张',
      key: 'picNum'
    })
    return false
  }
  if (file.size > 1024 * 1024 * 50) {
    message.error({
      content: '图片大小不能超过50M',
      key: 'picSize'
    })
    return false
  } else {
    return true
  }
}

const videoPrevCheck = (file, fileList) => {
  if (fileList.length > 10) {
    message.error({
      content: '上传视频数量不得超过10个',
      key: 'videoNum'
    })
    return false
  }
  if (file.size > 1024 * 1024 * 500) {
    message.error({
      content: '视频大小不能超过500M',
      key: 'videoSize'
    })
    return false
  } else {
    return true
  }
}

export class UploadImage extends Component {
  onchangehandler(val) {
    this.props.onChange(val)
  }

  render() {
    const { value } = this.props

    return (
      <>
        <span>
          可选，如收款凭证、聊天截图、服务合同截图等。图片大小不能超过 50 MB
        </span>
        <Upload
          multiple
          accept="image/*"
          upText="点击上传"
          max={50}
          onChange={val => this.onchangehandler(addchangeAttr(val))}
          beforeUpload={picPrevCheck}
          value={value}
        />
      </>
    )
  }
}

export class UploadVideo extends Component {
  onchangehandler(val) {
    this.props.onChange(val)
  }
  render() {
    const { value } = this.props
    const imageValue = value?.filter(e => e.type.includes('image')) || []
    const videoValue = value?.filter(e => e.type.includes('video')) || []

    const labelStyle = {
      backgroundColor: '#fafafa',
      color: '#666',
      width: 90,
      padding: 10,
      lineHeight: 1.5,
      textAlign: 'center'
    }

    const labelStyle1 = {
      ...labelStyle,
      borderTop: '1px solid #e2e2e2'
    }

    const tableStyle = {
      border: '1px solid #e2e2e2',
      width: '100%',
      margin: '10px 0'
    }

    const areaStyle = {
      paddingLeft: 10,
      paddingTop: 10
    }

    const areaStyle1 = {
      ...areaStyle,
      borderTop: '1px solid #e2e2e2'
    }

    return (
      <>
        <span>
          如需认证，必须上传婚礼现场原片或视频。图片大小不能超过
          50MB，视频大小不能超过 500 MB
        </span>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <td style={labelStyle}>婚礼现场照片</td>
              <td style={areaStyle}>
                <Upload
                  multiple
                  accept="image/*"
                  upText="点击上传"
                  max={50}
                  onChange={val =>
                    this.onchangehandler(addchangeAttr(videoValue.concat(val)))
                  }
                  beforeUpload={picPrevCheck}
                  value={imageValue}
                />
              </td>
            </tr>
            <tr>
              <td style={labelStyle1}>婚礼现场视频</td>
              <td style={areaStyle1}>
                <Upload
                  upText="点击上传"
                  accept="video/*"
                  clipOnUpComplete
                  clipable={false}
                  listMode
                  listType="picture-card"
                  previewable
                  max={10}
                  progress={{
                    strokeWidth: 5,
                    format: percent => ~~percent + '%'
                  }}
                  onChange={val =>
                    this.onchangehandler(addchangeAttr(imageValue.concat(val)))
                  }
                  beforeUpload={videoPrevCheck}
                  value={videoValue}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </>
    )
  }
}

export class InputPrice extends Component {
  render() {
    const { value, onChange } = this.props

    return (
      <>
        <InputNumber
          placeholder="请输入参考价格"
          style={{ width: 240 }}
          onChange={val => onChange(val)}
          value={value}
        />
        <span style={{ marginLeft: 10 }}>元</span>
      </>
    )
  }
}
